
import { defineComponent } from 'vue';
import { Item } from '@/types/Item';

interface State {
  isFormVisible: boolean;
  itemText: string;
}

export default defineComponent({
  data() {
    return {
      isFormVisible: false,
      itemText: '',
    };
  },

  methods: {
    showForm(): void {
      this.isFormVisible = true;
    },

    closeForm(): void {
      this.isFormVisible = false;
    },

    addItem() {
      this.$emit('addItem', {
        id: Date.now(),
        text: this.itemText,
        status: false,
      });

      this.itemText = '';
    },
  },

  emits: {
    addItem: (item: Item) => item,
  },
});
